import { requestWithToken } from '../utilities/request';
// import * as _ from 'lodash';
const path = '/api/private/';

const list = (company_id, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`ccus/companies/${company_id}`),
    params: param,
  });
};

const update = (company_id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`ccus/companies/${company_id}`),
    data: param,
  });
};

const createBasicInfo = (company_id, param) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`ccus/companies/${company_id}/ccus_basic_info`),
    data: param,
  });
};

const getBasicInfo = (company_id, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`ccus/companies/${company_id}/ccus_basic_info`),
    params: param,
  });
};

const deleteBasicInfo = company_id => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`ccus/companies/${company_id}/ccus_basic_info`),
  });
};

const updateBasicInfo = (company_id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`ccus/companies/${company_id}/ccus_basic_info`),
    data: param,
  });
};

const getListUsersInfo = (company_id, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`ccus/companies/${company_id}/users`),
    params: param,
  });
};

const updateUserInfo = (company_id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`ccus/companies/${company_id}/users`),
    data: param,
  });
};

const getListAdditionInfo = (company_id, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`ccus/companies/${company_id}/ccus_addition_info`),
    params: param,
  });
};

const createAdditionInfo = (company_id, param) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`ccus/companies/${company_id}/ccus_addition_info`),
    data: param,
  });
};

const getAdditionInfo = (company_id, id) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`ccus/companies/${company_id}/ccus_addition_info/${id}`),
  });
};

const updateAdditionInfo = (company_id, id, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`ccus/companies/${company_id}/ccus_addition_info/${id}`),
    data: param,
  });
};

const connectConfirmation = (companyId, data) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(
      `ccus/companies/${companyId}/confirm_ccus_connection/begin_fetch`
    ),
    data,
  });
};

const connectCcusFetchData = (companyId, params) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(
      `ccus/companies/${companyId}/confirm_ccus_connection/fetch`
    ),
    params,
  });
};

const deleteAdditionInfo = (company_id, id) => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`ccus/companies/${company_id}/ccus_addition_info/${id}`),
  });
};

const getAgencyInfo = (company_id, param) => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`ccus/companies/${company_id}/agency_info`),
    params: param,
  });
};

export const PrimeCCUSPreviewService = {
  list,
  update,
  createBasicInfo,
  getBasicInfo,
  deleteBasicInfo,
  updateBasicInfo,
  getListUsersInfo,
  updateUserInfo,
  getListAdditionInfo,
  createAdditionInfo,
  getAdditionInfo,
  updateAdditionInfo,
  connectConfirmation,
  connectCcusFetchData,
  deleteAdditionInfo,
  getAgencyInfo,
};
export default PrimeCCUSPreviewService;



// WEBPACK FOOTER //
// ./src/services/PrimeCCUSPreview.js